import { useEffect, useMemo, useState } from "react";
import { useGetUserQuery } from "../../apis/users.api";
import GiftIcon from "../svg/GiftIcon";
import TemporaryDrawer from "../ui/temp-drawer.component";
import { disableBodyScroll, enableBodyScroll } from "../../utils/HtmlHelper";
import CryptoRewardDrawerContent from "./crypto-rewards-drawer-content.component";
import React from "react";
import { DateTime } from "luxon";
import { User } from "../../models/User";
import { hasElements } from "../../utils/Helper";

interface CryptoRewardsDrawerProps {
  user: User;
}

const CryptoRewardsDrawer: React.FC<CryptoRewardsDrawerProps> = ({user}) => {

  // console.log('start: CryptoRewardsDrawer');

  const [open, setOpen] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect( () => {

    if(user?.cryptoRewards){
      user.cryptoRewards.map((reward) => {
        if(!reward.wallet_public_address){
          setAnimate(true);
        }
      })
    }

  },[open, animate]);

  const openDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  return (
    <>
      { user.cryptoRewards && !!user.cryptoRewards?.length && <>

        <div className={`md:flex flex-col self-end center`} onClick={openDrawer}>
          <div className={"h-[21px] px-1.5 bg-black bg-opacity-30 rounded border border-black border-opacity-10 justify-center center relative"}>
            <GiftIcon h={13} animate={animate}/>
          </div>
        </div>

        <TemporaryDrawer title={`Crypto Rewards`}
          anchor={'bottom'}
          open={open}
          closeWhenClickingOutside={true}
          lineIcon={false}
          onOpen={() => {
            disableBodyScroll();
            setOpen(true);
          }}
          onClose={() => {
            enableBodyScroll();
            closeDrawer();
          }}
          size="auto"
        >
          <div className="h-full content-center overflow-y-auto pb-10">
            <div className="flex flex-col">
              <CryptoRewardDrawerContent rewards={user.cryptoRewards}/>
            </div>
          </div>

        </TemporaryDrawer>

      </>
      }
    </>
  );
}

export default CryptoRewardsDrawer;